import { CUSTOM_LESSON_VIEW_TAG_SLUG, CustomLessonViewTag as CustomLessonViewTagType } from '@yandex-int/k-common';
import { Calendar, Cog, ClockClear, Desktop, Document, Route, Tube, Volume } from 'education-icons';
import { Text } from 'platform-components/common';
import React, { useMemo } from 'react';

import './custom-lesson-view__tag.scss';

interface Props {
    tag: CustomLessonViewTagType;
}

export const CustomLessonViewTag = React.memo(({ tag }: Props) => {
    const { slug, text } = tag;
    // eslint-disable-next-line complexity
    const icon = useMemo(() => {
        switch (slug) {
            case CUSTOM_LESSON_VIEW_TAG_SLUG.DESKTOP:
                return <Desktop />;
            case CUSTOM_LESSON_VIEW_TAG_SLUG.DOCUMENT:
                return <Document />;
            case CUSTOM_LESSON_VIEW_TAG_SLUG.MODE:
                return <Cog />;
            case CUSTOM_LESSON_VIEW_TAG_SLUG.PLAN:
                return <Calendar />;
            case CUSTOM_LESSON_VIEW_TAG_SLUG.TIME:
                return <ClockClear />;
            case CUSTOM_LESSON_VIEW_TAG_SLUG.TUBE:
                return <Tube />;
            case CUSTOM_LESSON_VIEW_TAG_SLUG.TYPE:
                return <Route />;
            case CUSTOM_LESSON_VIEW_TAG_SLUG.VOICE:
                return <Volume />;
            default:
                return null;
        }
    }, [slug]);

    return (
        <div className="custom-lesson-view__tag">
            <div className="custom-lesson-view__tag-icon">{icon}</div>
            <Text>{text}</Text>
        </div>
    );
});
